import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const DataRefreshIndicator = () => {
  const [lastRefresh, setLastRefresh] = useState(new Date());
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [nextRefresh, setNextRefresh] = useState(60);

  useEffect(() => {
    const refreshInterval = setInterval(() => {
      setNextRefresh(prev => {
        if (prev <= 1) {
          handleAutoRefresh();
          return 60;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(refreshInterval);
  }, []);

  const handleAutoRefresh = () => {
    setIsRefreshing(true);
    setLastRefresh(new Date());
    
    setTimeout(() => {
      setIsRefreshing(false);
    }, 1500);
  };

  const handleManualRefresh = () => {
    if (isRefreshing) return;
    
    setIsRefreshing(true);
    setLastRefresh(new Date());
    setNextRefresh(60);
    
    setTimeout(() => {
      setIsRefreshing(false);
    }, 1500);
  };

  const formatTime = (date) => {
    return date?.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  };

  const formatNextRefresh = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs?.toString()?.padStart(2, '0')}`;
  };

  return (
    <div className="fixed top-20 right-6 z-100 bg-card border border-border rounded-md shadow-md px-4 py-2 transition-smooth">
      <div className="flex items-center gap-3">
        <button
          onClick={handleManualRefresh}
          disabled={isRefreshing}
          className={`
            flex items-center justify-center w-8 h-8 rounded-md transition-smooth
            ${isRefreshing 
              ? 'bg-muted cursor-not-allowed' :'hover:bg-muted active:scale-press cursor-pointer'
            }
          `}
          aria-label="Refresh data"
          title="Refresh data manually"
        >
          <Icon 
            name="RefreshCw" 
            size={18} 
            color="var(--color-primary)" 
            className={isRefreshing ? 'animate-spin' : ''}
          />
        </button>

        <div className="hidden md:flex flex-col">
          <div className="flex items-center gap-2">
            <span className="caption text-xs text-muted-foreground">Last updated:</span>
            <span className="data-text text-xs font-medium text-foreground">
              {formatTime(lastRefresh)}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="caption text-xs text-muted-foreground">Next refresh:</span>
            <span className="data-text text-xs font-medium text-foreground">
              {formatNextRefresh(nextRefresh)}
            </span>
          </div>
        </div>

        <div className="md:hidden">
          <Icon 
            name={isRefreshing ? 'Loader2' : 'Clock'} 
            size={16} 
            color="var(--color-muted-foreground)"
            className={isRefreshing ? 'animate-spin' : ''}
          />
        </div>
      </div>
    </div>
  );
};

export default DataRefreshIndicator;